import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor, BlocksPreviewData } from 'thunderbolt-viewer-manager-types'
import { CarmiInstance, EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import { ViewerManagerBlocksApiEditorConfig } from './types'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'

const viewerManagerBlocksApiFactory = (
	config: ViewerManagerBlocksApiEditorConfig,
	{ blocks: setter }: DSCarmi
): IViewerManagerImplementor<'blocks'> => {
	return {
		blocks: {
			setBlocksPreviewData: (data: BlocksPreviewData) => {
				setter.setBlocksPreviewData(data)
			},
			getBlocksPreviewData: () => config.blocksPreviewData,
		},
	}
}
export const ViewerManagerBlocksApi = withDependencies(
	[named(EditorFeatureConfigSymbol, name), CarmiInstance],
	viewerManagerBlocksApiFactory
)
